import { BuyerInvoicesResponse, NotificationResponse } from '@types'

export function invoiceToNotificationTransform(
  response: BuyerInvoicesResponse
): NotificationResponse {
  return {
    notifications: response.invoices.map((invoice) => {
      const invoice_installments = invoice.invoice_installments
      return {
        id: invoice.id,
        type: 'pending-invoice',
        data: {
          seller_name: invoice.seller_name,
          amount_cents: invoice.amount_cents,
          installments: invoice_installments.length,
          installment_amount_cents: invoice_installments[0]?.amount_cents,
        },
      }
    }),
  }
}
